import { connect } from 'react-redux';
import { setMainNotificationVisibility } from 'store/ui/notifications/actions';
import PersonalVideosNotification from './PersonalVideosNotification';

const enhance = connect(null, {
    setMainNotificationVisibility,
});

export default enhance(PersonalVideosNotification);
